import { Fragment, useEffect, useMemo, useState, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Dropdown, Navbar } from "react-bootstrap";
import keycloak from "../../keycloak/keycloak";
import { MissionStore, setMission, setMissions, setProjectsData, setRoute, setSatellites, setSatellitesDetails, setUserData } from "../../store/MissionSlice";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../../service/UserService";
import { updateUserToken } from "../../components/CommonComponents/CommonLoginFun";
import MissionService from "../../service/MissionService";
import { collectEnable } from "../../utils/commonFunctions";
import { ACP_RELEASE_VERSION, ACP_SATOS_VERSION } from "../../release-version";
export const CATALOG_ENTRY_PATH = 'catalog?sidebar=expanded&header=true&drawer=true&category=payload&sub_category=earth_observation'
export const MISSION_DESIGN_ENTRY_PATH = (missionId: string) => `mission-design/${missionId}?sidebar=expanded&header=true`

/**
 * Mission Design is a separate Next.js app, so it must be opened with a full page load
 * (not react-router's navigate) and in the SAME tab so sessionStorage (auth/userDetails) is shared.
 * `returnUrl` tells the Next.js app where its Back button should return to.
 */
export const getMissionDesignUrl = (missionId: string, returnUrl: string) =>
  `${process.env.PUBLIC_URL}/${MISSION_DESIGN_ENTRY_PATH(missionId)}&returnUrl=${encodeURIComponent(returnUrl)}`


const Header = ({ setLoading, hide_header }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { mission_id, tab_name, dashboard } = params

  const userData: any = useSelector((state: { mission: MissionStore }) => state.mission.userData);
  const Mission: any = useSelector((state: { mission: MissionStore }) => state.mission.Mission);
  const route = useSelector((state: { mission: MissionStore }) => state.mission.route);

  const [openAboutSection, setOpenAboutSection] = useState(false)
  const location = useLocation()
  const pathname = window.location.pathname
  let [isCurrentlyActive, setIsCurrentlyActive] = useState('mission')

  const get_user_data = () => {
    if (sessionStorage.getItem("userDetails")) {
      // @ts-ignore
      let user_data = JSON.parse(sessionStorage.getItem("userDetails"));
      if (user_data?.['owner_org'] && user_data?.['owner_org'] !== '') {
        UserService.get_User_By_Tenant(user_data?.['owner_org'])?.then(data => {
          if (data?.data) {
            let update_user_data = {
              ...user_data,
              'isBetaVersion': data.data?.['isBetaVersion'],
              'feature-allowed': data.data?.['feature-allowed'],
              'owner_name': data.data?.['ownerOrg'],
            }
            sessionStorage.setItem("userDetails", JSON.stringify(update_user_data));
            dispatch(setUserData(update_user_data));
          }
        }).catch((err) => {
          console.log(err);
        })
      }
      dispatch(setUserData(user_data));
    }
  }

  useEffect(() => {
    get_user_data();
  }, [])

  useEffect(() => {
    dispatch(setRoute({
      to: location.pathname,
      from: route.to
    }))
  }, [location]);

  const get_mission = () => {
    MissionService.get_mission_by_id(mission_id)?.then((res) => {
      if (res.data) {
        dispatch(setMission(res.data))
      }
    }).catch((err) => {
      console.error(err);
    })
  }

  useEffect(() => {
    if (mission_id && Object.keys(Mission)?.length === 0) {
      get_mission()
    }
  }, [mission_id])

  const goto = (url) => {
    let path = `${process.env.PUBLIC_URL}/${url}`;
    navigate(path);
  };

  useEffect(() => {
    dispatch(
      setRoute({
        to: location.pathname,
        from: route.to,
      })
    );
  }, [location]);

  const [show, setShow] = useState(false); //profile dropdown state
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Toggle dropdown when clicking the toggle
  const handleToggle = () => setShow(!show);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if (pathname.includes('/_details') || pathname.includes('/satellites') || pathname.includes('/sat_details') || pathname.includes('/payload_details') || pathname.includes('/add_new_payload') || pathname.includes('/preview_payload') || pathname.includes('/edit_payload') ||
      pathname.includes('/add_new_edge') || pathname.includes('/preview_edge') || pathname.includes('/edit_edge') || pathname.includes('/add_new_template') || pathname.includes('/station_provider') || pathname.includes('/ground_station') ||
      pathname.includes('/edit_template') || pathname.includes('/review_satellite') || pathname.includes('/clone_bus_design') || pathname.includes('/view_satellite') || pathname.includes('/template')) {
      setIsCurrentlyActive('design')
    } else if (pathname.includes('/operate-dashboard') || dashboard === 'operate') {
      setIsCurrentlyActive('operate')
    } else if (pathname.includes('/simulate') || pathname.includes('/create_scenario') || pathname.includes('/update_scenario') || pathname.includes('/dashboard') || dashboard === 'summary' || dashboard === 'quick-deploy' || dashboard === 'simulation') {
      setIsCurrentlyActive('simulate')
    } else if (pathname.includes('/validate') || pathname.includes('/validation')) {
      setIsCurrentlyActive('validate')
    } else if (pathname.includes('/settings')) {
      setIsCurrentlyActive('settings')
    } else if (pathname.includes('/collect')) {
      setIsCurrentlyActive('collect')
    } else if (pathname.includes('/catalogs')) {
      setIsCurrentlyActive('catalogs')
    } else {
      setIsCurrentlyActive('mission')
    }
  }, [pathname]);

  const handleLogout = () => {
    if (sessionStorage.getItem("userDetails")) {
      setLoading(true);
      // @ts-ignore
      let currentUserData = JSON.parse(sessionStorage.getItem("userDetails"));
      sessionStorage.removeItem("userDetails");
      if (
        currentUserData?.["resource_access"]?.["ATMOS-RESOURCE-SERVER"]?.[
          "roles"
        ]?.includes("super_admin")
      ) {
        UserService.updateUser(currentUserData?.["sub"], { ownerOrg: "", 'firstName': userData?.['given_name'], 'lastName': userData?.['family_name'] })
          ?.then((res) => {
            if (res) {
              keycloak
                .logout({
                  redirectUri: window.location.origin,
                })
                .then((success) => {
                  sessionStorage.removeItem("authentication");
                  sessionStorage.removeItem("refreshToken");
                  setLoading(false);
                })
                .catch((error) => {
                  sessionStorage.removeItem("authentication");
                  sessionStorage.removeItem("refreshToken");
                  setLoading(false);
                })
                .finally(() => {
                  setShow(false);
                })
            }
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          })
          .finally(() => {
            setShow(false);
          })
      } else {
        keycloak
          .logout({
            redirectUri: window.location.origin,
          })
          .then((success) => {
            sessionStorage.removeItem("authentication");
            sessionStorage.removeItem("refreshToken");
            setLoading(false);
          })
          .catch((error) => {
            sessionStorage.removeItem("authentication");
            sessionStorage.removeItem("refreshToken");
            setLoading(false);
          })
          .finally(() => {
            setShow(false);
          })
      }
    }
  };

  const updateUserDetails = () => {
    if (sessionStorage.getItem("userDetails")) {
      setLoading(true);
      // @ts-ignore
      let currentUserData = JSON.parse(sessionStorage.getItem("userDetails"));
      // @ts-ignore
      let token = sessionStorage.getItem("authentication");
      let data = { ownerOrg: "", 'firstName': userData?.['given_name'], 'lastName': userData?.['family_name'] }
      let owner_name = ''
      UserService.updateUser(currentUserData?.["sub"], data)
        ?.then((res) => {
          if (res) {
            updateUserToken(token, owner_name, dispatch, navigate, setLoading);
            dispatch(setMission({}))
            dispatch(setMissions([]))
            dispatch(setProjectsData([]))
            dispatch(setSatellites([]));
            dispatch(setSatellitesDetails([]));
          };
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        })
        .finally(() => {
          setShow(false);
        });
    }
  };

  const collect = useMemo(() => collectEnable(), [collectEnable])

  const isCollectEnabled = () => {
    return (Mission?.['missionTitle'] && userData?.['feature-allowed']?.['collect'] === 'Yes' && collect) ? true : false
  }


  return (
    <Fragment>
      <div className='app__header' style={{ display: hide_header ? 'none' : 'flex' }}>
        <div className="d-flex justify-content-between px-5 align-items-center w-100">
          <div className="d-flex align-items-center w-auto">
            <Link
              to={pathname?.includes('super_admin_dashboard') ? `${process.env.PUBLIC_URL}/super_admin_dashboard` : pathname?.includes('user') ? `${process.env.PUBLIC_URL}/user/${userData?.['name']}/${userData?.['sub']}` : `${process.env.PUBLIC_URL}/`}
            >
              <img
                src={require("../../assets/images/brand/logo-white.png")}
                height={30}
                className='ms-2 mt-2'
                alt="logo"
              />

            </Link>
            {Mission && isCurrentlyActive !== '' && window.location.pathname !== "/super_admin_dashboard" && (
              <div className="sat-nav">
                {/* <span className={
                      isCurrentlyActive === 'mission' ? "active" : ""
                    } onClick={()=>{goto(``)}}
                  >Mission</span>
                  <span>|</span> */}
                <span id="satNav_Design"
                  className={
                    isCurrentlyActive === 'design' ? "active" : !Mission?.['missionTitle'] ? "disabled" : ""
                  }
                  onClick={() => {
                    if (Mission?.['missionTitle']) {
                      goto(`${Mission.missionTitle}/_details/${Mission.uniqueId}/${(tab_name && (tab_name === 'Satellites' || tab_name === 'Modelling' || tab_name === 'Ground_Stations')) ? tab_name : 'Satellites'}`)
                    }
                  }}
                >
                  Design
                </span>

                <span id="satNav_Simulate"
                  className={
                    isCurrentlyActive === 'simulate' ? "active" : !Mission?.['missionTitle'] ? "disabled" : ""
                  }
                  onClick={() => {
                    if (Mission?.['missionTitle']) {
                      goto(`${Mission.missionTitle}/${Mission.uniqueId}/simulate`);
                    }
                  }}
                >
                  Simulate
                </span>
                {userData?.['feature-allowed']?.['validation'] === 'Yes' && (
                  <span id="satNav_Validate"
                    className={
                      isCurrentlyActive === 'validate' ? "active" : !Mission?.['missionTitle'] ? "disabled" : ""
                    }
                    onClick={() => {
                      if (Mission?.['missionTitle']) {
                        goto(`${Mission.missionTitle}/${Mission.uniqueId}/validate`);
                      }
                    }}
                  >
                    Validate
                  </span>
                )}
                <span id="satNav_Operate"
                  className={isCurrentlyActive === 'operate' ? "active" : (Mission?.['missionTitle'] && userData?.['feature-allowed']?.['operate'] === 'Yes') ? "" : "disabled"}
                  onClick={() => {
                    if (Mission?.['missionTitle'] && userData?.['feature-allowed']?.['operate'] === 'Yes') {
                      goto(`${Mission?.missionTitle}/${Mission.uniqueId}/operate-dashboard`);
                    }
                  }}
                >
                  Operate
                </span>

                {(<span id="satNav_Collect"
                  className={
                    isCurrentlyActive === 'collect' ? "active" : isCollectEnabled() ? "" : "disabled"
                  }
                  onClick={() => {
                    if (isCollectEnabled()) {
                      goto(`${Mission?.missionTitle}/${Mission.uniqueId}/collect`);
                    }
                  }}
                >
                  Orchestrate
                </span>)}
                {(<span id="satNav_Order"
                  className={(isCollectEnabled()) ? "" : "disabled"}
                  onClick={() => {
                    if (isCollectEnabled()) {
                      // Order: navigate to UDP
                      // AT-11671 Fix Navigation
                      // const url = `http://10.51.50.163:8080/`;
                      const url = `https://geodata-dev.udp.geminus.cloud`
                      const newTab = window.open(url, '_blank', 'noopener,noreferrer');
                      if (newTab) {
                        newTab.focus();
                      }
                    }
                  }}
                >
                  Order
                </span>)}
              </div>
            )}
          </div>

          <div className="d-flex align-items-center justify-content-center">
            <Navbar className="d-flex p-0">
              {Mission && window.location.pathname !== "/super_admin_dashboard" && userData?.['feature-allowed']?.['Catalogue'] === 'Yes' && (
                <div className="sat-nav">
                  <span id="satNav_Order"
                    className={
                      isCurrentlyActive === 'catalogs' ? "active" : Mission?.['missionTitle'] ? "" : "disabled"
                    }
                    onClick={() => {
                      if (Mission?.['missionTitle']) {
                        navigate(`/${Mission?.['missionTitle']}/${mission_id}/catalogs?sidebar=expanded&header=true&drawer=true&category=payload&sub_category=earth_observation`);
                      }
                    }}
                  >
                    Catalog
                  </span>
                </div>)}
              <div className="d-flex p-0 menu__container">
                <Navbar.Collapse className="" id="navbarSupportedContent-4">
                  <div className="d-flex ">
                    <Dropdown id="dropdown" className="d-flex profile-1" ref={dropdownRef} show={show}>
                      <Dropdown.Toggle
                        variant=""
                        id="dropdown_toggle"
                        className="nav-link leading-none d-flex no-caret"
                        onClick={handleToggle}
                      >
                        {userData?.['given_name'] && <div id="user_profile" className="nav-link-profile">
                          <span className="profile-avatar">
                            {userData?.given_name.slice(0, 1)}
                            {userData?.family_name.slice(0, 1)}
                          </span>
                        </div>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu id="dropdown_menu" className="dropdown-menu-end dropdown-menu-arrow">
                        <div className="drop-heading">
                          <div id="user_details" className="text-start d-flex flex-column w-100">
                            <span id="user_name" className="text-dark mb-0 fs-16 fw-semibold w-98 text-truncate" title={userData?.['name'] || `${userData?.given_name} ${userData?.family_name}`}>
                              {userData?.['name'] || `${userData?.given_name} ${userData?.family_name}`}
                            </span>
                            <small id="owner_name" className="text-muted w-98 text-truncate" title={userData?.["owner_name"]}>
                              {userData?.["owner_name"]}
                            </small>
                          </div>
                        </div>
                        {window.location.pathname !==
                          "/super_admin_dashboard" &&
                          userData?.["resource_access"]?.[
                            "ATMOS-RESOURCE-SERVER"
                          ]?.["roles"]?.includes("super_admin") && (
                            <Dropdown.Item
                              className="dropdown-item"
                              onClick={updateUserDetails}
                            >
                              <span id="dashboard_super_admin" className="d-flex gap-1 align-items-center ms-4">
                                <i className="dropdown-icon fe  fe-grid"></i>{" "}
                                Dashboard
                              </span>
                            </Dropdown.Item>
                          )}
                        {(window.location.pathname !== "/super_admin_dashboard" && !window.location.pathname.includes('/user') && !userData?.['user_roles']?.includes('super_admin')) && <Dropdown.Item
                          className="dropdown-item"
                          onClick={() => {
                            dispatch(setMission({}))
                            dispatch(setMissions([]))
                            dispatch(setProjectsData([]))
                            goto(`user/${userData?.['name']}/${userData?.["sub"]}`);
                            setShow(false);
                          }}
                        >
                          <span id="dashboard_user" className="d-flex gap-1 align-items-center ms-4">
                            <i className="dropdown-icon fe  fe-grid"></i>{" "}
                            Dashboard
                          </span>
                        </Dropdown.Item>}
                        {window.location.pathname !==
                          "/super_admin_dashboard" && <Dropdown.Item
                            className="dropdown-item"
                            onClick={() => {
                              goto("settings");
                              setShow(false);
                            }}
                          >
                            <span id="user_settings" className="d-flex gap-1 align-items-center ms-4">
                              <i className="dropdown-icon fe  fe-settings"></i>{" "}
                              Settings
                            </span>
                          </Dropdown.Item>}
                        <Dropdown.Item
                          className="dropdown-item"
                          onClick={() => { setOpenAboutSection(true); setShow(false); }}
                        >
                          <span id="about_asp" className="d-flex gap-1 align-items-center">
                            <img src={require('../../assets/images/brand/logoheader.png')} height={20} alt='l' />
                            About ASP
                          </span>
                        </Dropdown.Item>
                        {userData?.['isBetaVersion'] === 'Yes' &&
                          <a target="_blank" rel="noopener noreferrer" href="https://docs.antaris.space/" className="dropdown-item" onClick={() => setShow(false)}>
                            <span className="d-flex gap-1 align-items-center ms-4 ">
                              <i className="dropdown-icon fe fe-file-text"></i>{" "}
                              Documentation
                            </span>
                          </a>
                        }
                        <Dropdown.Item
                          className="dropdown-item"
                          onClick={handleLogout}
                        >
                          <span id="sign_out" className="d-flex gap-1 align-items-center ms-4">
                            <i className="dropdown-icon fe fe-log-out"></i>
                            Sign out
                          </span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </div>
        </div>
      </div>
      {openAboutSection && <div className="about_asp_section" onClick={() => { setOpenAboutSection(false) }}>
        <div className="about_asp">
          <div className="about_asp_close"><i onClick={() => { setOpenAboutSection(false) }} className="fe fe-x-circle me-1 fs-18" ></i></div>
          <div className="d-flex flex-column gap-4 align-items-center">
            <img src={require("../../assets/images/brand/logo-white.png")} className="w-40 h-25" alt="logo" />
            <div className="d-flex flex-column align-items-center">
              <span className="color-atmos fs-18">Version {ACP_RELEASE_VERSION}</span>
              <span className="color-atmos-white fs-14 opacity-75">SatOS Version {ACP_SATOS_VERSION}</span>
            </div>


          </div>
          <div className="d-flex align-items-center justify-content-center w-100 gap-3 mt-3">
            <a className="acp__button cursor-pointer" target="_blank" href="https://docs.antaris.space">Documentation</a>
            <a className="acp__button cursor-pointer" target="_blank" href="https://docs.antaris.space/terms-of-service">Terms of Service</a>
          </div>
        </div>
      </div>}
    </Fragment>
  );
};

export default Header;
